import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Trans, useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import {
  PRE_ACTIVATION_HERO_DESCRIPTION,
  PRE_ACTIVATION_HERO_DESCRIPTION_AGENCY,
  PRE_ACTIVATION_HERO_TITLE,
} from "../../../i18n/keysTranslations";
import { PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY } from "../preActivationFormValues";
import OrganizationTypeSection from "./OrganizationTypeSection";

const HeroSection = ({
  control,
  readOnly = false,
  onOrganizationTypeChange,
}) => {
  const { t } = useTranslation();
  const organizationType = useWatch({ control, name: "organizationType" });
  const isAgency = organizationType === PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY;
  const descriptionKey = isAgency
    ? PRE_ACTIVATION_HERO_DESCRIPTION_AGENCY
    : PRE_ACTIVATION_HERO_DESCRIPTION;

  return (
    <>
      <Typography
        component="h1"
        sx={{
          fontSize: "28px",
          fontWeight: 900,
          color: "text.primary",
          letterSpacing: "-0.8px",
          lineHeight: 1.15,
          marginBottom: "10px",
        }}
      >
        <Trans
          i18nKey={PRE_ACTIVATION_HERO_TITLE}
          components={{
            br: <br />,
            em: (
              <Box
                component="em"
                sx={{
                  fontStyle: "normal",
                  color: "text.primary",
                }}
              />
            ),
          }}
        />
      </Typography>

      <Typography
        component="p"
        sx={{
          fontSize: "14px",
          color: "text.secondary",
          lineHeight: 1.6,
          maxWidth: "480px",
        }}
      >
        {t(descriptionKey)}
      </Typography>

      <Box sx={{ marginTop: "24px" }}>
        <OrganizationTypeSection
          control={control}
          readOnly={readOnly}
          onOrganizationTypeChange={onOrganizationTypeChange}
        />
      </Box>
    </>
  );
};

export default HeroSection;
